module.exports = __webpack_public_path__ + "img/logo1.1.a30a5a27.png";